import "@web-components/predictive-search";
import "@web-components/drawer";

function insertTriggers() {
  const searchLinks = document.querySelectorAll<HTMLAnchorElement>(
    'a[href*="/search"]:not([href*="page="])',
  );
  searchLinks.forEach((link) => {
    if (link.parentElement?.tagName === "DRAWER_TRIGGER") return;
    const clonedLink = link.cloneNode(true) as HTMLAnchorElement;
    const drawerTrigger = document.createElement("drawer-trigger");
    drawerTrigger.setAttribute("action", "open");
    drawerTrigger.setAttribute("on", "click");
    drawerTrigger.setAttribute("target", "#searchNavigationDrawer");
    drawerTrigger.setAttribute("prevent-default", "true");
    drawerTrigger.append(clonedLink);

    link.replaceWith(drawerTrigger);
  });
}

insertTriggers();

// if (window.Shopify.designMode) {
//   window.addEventListener('shopify:section:load', function (event) {
//     insertTriggers();
//   });

//   const [isSelected, setIsSelected] = createSignal(false),
//     [drawer, setDrawer] = createSignal<HTMLElement | null>(null),
//     sectionId = `shopify-section-{{ section.id }}`;

//   let section = document.getElementById(sectionId);

//   function isThisSection(targetId: string) {
//     const result = targetId === `{{ section.id }}`;
//     return result;
//   }

//   function onSectionSelect(event: CustomEvent) {
//     if (!isThisSection(event.detail.sectionId)) return;
//     setIsSelected(true);
//   }

//   function onSectionDeselect(event: CustomEvent) {
//     if (!isThisSection(event.detail.sectionId)) return;
//     setIsSelected(false);
//   }

//   function onSectionLoad(event: CustomEvent) {
//     if (!isThisSection(event.detail.sectionId)) return;
//     addEvents(event.target as HTMLElement);
//     section = event.target as HTMLElement;
//   }

//   function onSectionUnload(event: CustomEvent) {
//     if (!isThisSection(event.detail.sectionId)) return;
//     setDrawer(null);
//     //@ts-ignore
//     document.removeEventListener('shopify:section:unload', onSectionUnload);
//     //@ts-ignore
//     document.removeEventListener('shopify:section:select', onSectionSelect);
//     //@ts-ignore
//     document.removeEventListener('shopify:section:deselect', onSectionDeselect);
//     //@ts-ignore
//     document.removeEventListener('shopify:block:select', onSectionSelect);
//   }

//   function addEvents(section: HTMLElement) {
//     //@ts-ignore
//     document.addEventListener('shopify:section:unload', onSectionUnload);
//     //@ts-ignore
//     document.addEventListener('shopify:section:select', onSectionSelect);
//     //@ts-ignore
//     document.addEventListener('shopify:section:deselect', onSectionDeselect);
//     //@ts-ignore
//     document.addEventListener('shopify:block:select', onSectionSelect);
//   }

//   createEffect(
//     on(
//       () => ({ drawer: drawer(), isSelected: isSelected() }),
//       ({ drawer, isSelected }) => {
//         if (!drawer) return;
//         const isOpen = drawer.getAttribute('is-open') === 'true';

//         if (isOpen !== isSelected) drawer.setAttribute('is-open', `${isSelected}`);

//         console.log(isOpen, isSelected, drawer.getAttribute('is-open'));

//         function onDrawerToggle(event: CustomEvent) {
//           setIsSelected(event.detail.isOpen);
//         }

//         //@ts-ignore
//         drawer.addEventListener('drawer:toggle', onDrawerToggle);

//         return onCleanup(() => {
//           //@ts-ignore
//           drawer.removeEventListener('drawer:toggle', onDrawerToggle);
//         });
//       },
//     ),
//   );

//   //@ts-ignore
//   document.addEventListener('shopify:section:load', onSectionLoad);
//   addEvents(section as HTMLElement);
// }
